import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import logo from '../../assets/SenritsuXwordmarkwhite.png';
import '../../styles/Auth.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const { resetPassword } = useAuth();

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    try {
      await resetPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 440, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src={logo} alt="SenritsuX" className="auth-brand-logo" style={{ marginBottom: '1.5rem' }} />
        </div>

        <h2 className="auth-heading">Forgot Password</h2>
        <p className="auth-subheading">
          Enter your email and we&apos;ll send you a link to reset your password.
        </p>

        {error && (
          <div className="auth-global-error">
            <span>⚠</span>
            <span>{error}</span>
          </div>
        )}

        {success ? (
          <>
            <div className="auth-global-success">
              <span>✓</span>
              <span>Password reset link sent to <strong>{email}</strong>. Check your inbox.</span>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
              Didn&apos;t get the email? Check your spam folder or try again.
            </p>
            <button className="auth-btn-secondary" onClick={() => { setSuccess(false); setEmail(''); }}>
              Try Another Email
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className="auth-form-group">
              <label className="auth-label" htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                type="email"
                className={`auth-input ${error && !email ? 'error' : ''}`}
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                autoComplete="email"
              />
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? <span className="auth-spinner" /> : 'Send Reset Link'}
            </button>
          </form>
        )}

        <div className="auth-footer-text">
          Remember your password? <Link to="/login">Sign In</Link>
        </div>
      </div>
    </div>
  );
}
